import React, { useState } from "react";

const FallbackLogicBox = ({ restaurantConfig, setRestaurantConfig }) => {
  const fallback =
    restaurantConfig?.delivery_config?.base_components?.distance_logic
      ?.fallback_logic || {};

  const maxTierKm =
    restaurantConfig?.delivery_config?.base_components?.distance_logic?.tiers?.at(-1)
      ?.max_km || 0;

  // Initial values from restaurantConfig
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    distance: maxTierKm, // distance threshold, e.g. 15
    base_fee_start: fallback.base_fee_start,
    additional_per_km: fallback.additional_per_km,
  });

  const handleSave = () => {
    // Update restaurantConfig state
    const updated = {
      ...restaurantConfig,
      delivery_config: {
        ...restaurantConfig.delivery_config,
        base_components: {
          ...restaurantConfig.delivery_config.base_components,
          distance_logic: {
            ...restaurantConfig.delivery_config.base_components.distance_logic,
            fallback_logic: {
              ...fallback,
              description: `Applied if distance > max tier (${form.distance}km)`,
              base_fee_start: Number(form.base_fee_start),
              additional_per_km: Number(form.additional_per_km),
            },
          },
        },
      },
    };

    setRestaurantConfig(updated);
    setEditMode(false);
  };

  return (
    <div
      style={{
        background: "#FFE7C2",
        border: "1px solid #FFB26B",
        padding: "12px",
        borderRadius: "10px",
        marginBottom: "15px",
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center'
      }}
    >
      {!editMode ? (
        <>
          <div style={{ color: "#B3541E", fontWeight: 600, fontSize: "15px" }}>
            Fallback logic : If distance &gt; {form.distance}km, base fee ₹
            {fallback.base_fee_start} + ₹{fallback.additional_per_km} /km
          </div>

          <button
            style={{
              // marginTop: "8px",
              background: "#FF8A3D",
              color: "white",
              padding: "5px 14px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => setEditMode(true)}
          >
            Edit
          </button>
        </>
      ) : (
        <>
          <div style={{ fontWeight: 600, marginBottom: "10px", color: "#B3541E" }}>
            Edit Fallback Logic
          </div>

          <div style={{ marginBottom: "8px" }}>
            <label>Distance (km): </label>
            {/* <input
              type="number"
              value={form.distance}
              onChange={(e) =>
                setForm({ ...form, distance: e.target.value })
              }
            /> */}
            <span className="fall-text-display">{form.distance} km</span>
          </div>

          <div style={{ marginBottom: "8px" }}>
            <label>Base Fee (₹): </label>
            <input
              type="number"
              value={form.base_fee_start}
              onChange={(e) =>
                setForm({ ...form, base_fee_start: e.target.value })
              }
            />
          </div>

          <div style={{ marginBottom: "8px" }}>
            <label>Additional Per Km (₹): </label>
            <input
              type="number"
              value={form.additional_per_km}
              onChange={(e) =>
                setForm({ ...form, additional_per_km: e.target.value })
              }
            />
          </div>

          <button
            style={{
              marginTop: "10px",
              background: "#1E8F44",
              color: "white",
              padding: "6px 14px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={handleSave}
          >
            Save
          </button>
        </>
      )}
    </div>
  );
};

export default FallbackLogicBox;
